import {
  getPrioritizationResultsRequest,
  getPrioritizationResultsResponse,
} from '@core-api/presentation/presentation/interactive-content/{interactive_content_id}/prioritization-results';
import { getFetchResultsCacheKey } from '@mentimeter/core-hooks';
import { useFetchResultsBase } from './use-fetch-results-base';

interface UseFetchHundredPointsResultsParams {
  adminKey: string;
  interactiveContentId: string;
  shouldFetchResults: boolean;
  sessionId: number | undefined;
}

export const useFetchHundredPointsResults = ({
  adminKey,
  interactiveContentId,
  shouldFetchResults,
  sessionId,
}: UseFetchHundredPointsResultsParams) => {
  const requestParams = { interactiveContentId };
  const cacheKey = adminKey
    ? getFetchResultsCacheKey('hundred-points', adminKey, sessionId)
    : null;

  return useFetchResultsBase({
    requestParams,
    cacheKey,
    shouldFetchResults,
    sessionId,
    getRequest: getPrioritizationResultsRequest,
    getResponse: getPrioritizationResultsResponse,
  });
};
